export const GridHeight = '100%';
export const GridWidth = '100%';

export const Width_100 = 100;
export const Width_110 = 110;
export const Width_120 = 120;
export const Width_125 = 125;
export const Width_130 = 130;
export const Width_167 = 167;
export const Width_1000 = 1000;
export const Width_300 = 300;
export const Width_350 = 350;
export const Width_380 = 380;
export const Width_320 = 320;
export const Width_384 = 384;
export const Width_400 = 400;
export const Width_450 = 450;
export const Width_480 = 480;
export const Width_70 = 70;
export const Width_85 = 85;
export const Width_30 = 30;
export const Width_80 = 40;
export const Width_50 = 50;
export const Width_135 = 135;
export const Width_138 = 138;
export const Width_150 = 150;
export const Width_158 = 158;
export const Width_171 = 171;
export const Width_180 = 180;
export const Width_160 = 160;
export const Width_190 = 190;
export const Width_200 = 200;
export const Width_210 = 210;
export const Width_215 = 215;
export const Width_220 = 220;
export const Width_280 = 280;
export const Width_290 = 290;
export const Width_330 = 330;
export const Width_500 = 500;
export const Width_530 = 530;
export const Width_600 = 600;
export const Width_800 = 800;
export const Width_250 = 250;
export const Length_100 = 100;
export const Length_50 = 50;
export const Length_30 = 30;
export const Length_20 = 20;
export const Length_10 = 10;
export const Length_5 = 5;
export const Length_1 = 1;
export const Length_255 = 255;
export const Length_3 = 3;
export const BorderColor = '#D6D2D0';
export const Width_240 = 240;
export const Width_270 = 270;
export const Width_230 = 230;
